import { css } from '@emotion/react';
import styled from '@emotion/styled';
import React from 'react';

import ContactCard from './ContactCard';
import UtilityBar from '../../ComponentLibrary/layout/oc-utility-bar';
import { Breadcrumb, Breadcrumbs } from '../../ComponentLibrary/oc-breadcrumbs';
import Container from '../../OC/oc-container';
import Hero from '../../OC/oc-hero';
import { connectLocation } from '../../location/LocationConnectors';
import { LocationSwitcher } from '../../location/Switcher';
import wrappedInReduxProvider from '../../wrappedInReduxProvider';

const Banner = styled.div`
  background: black;
  color: white;
  padding: 8px 10px;
  text-align: center;
  font-size: 14px;
  margin-bottom: 30px;

  a {
    color: white;
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }
`;

const UnstyledList = styled.ul`
  list-style: none;
  padding-left: 0;
  margin: 0;
`;

const renderSection = (title, data, zipcode) => (
  <div key={title}>
    <h2>{`${title} (${zipcode})`}</h2>
    <UnstyledList>
      {data.map((businessData, i) =>
        businessData.agents.map((agentData, j) => (
          <li key={`${i}-${j}`}>
            <ContactCard
              img={agentData.headshot}
              url={null}
              dark
              preHead={agentData.company}
              heading={businessData.description}
              postHead={`${agentData.first_name} ${agentData.last_name}`}
              trackType="Commercial Insulation Sales Representative"
              linkedIn={agentData.linkedin_url}
              name={`${agentData.first_name} ${agentData.last_name}`}
              email={agentData.email}
              phone={agentData.office_phone}
              mobilePhone={agentData.cell_phone}
              fax={agentData.fax}
            />
          </li>
        ))
      )}
    </UnstyledList>
  </div>
);

const SearchSalesRep = ({ zipCodeAgentsData, aecData, agentsData }) => (
  <>
    <UtilityBar>
      <Breadcrumbs>
        <Breadcrumb href="/insulation" label="Insulation" />
        <Breadcrumb href="/insulation/commercial" label="Commercial" />
      </Breadcrumbs>
      <LocationSwitcher />
    </UtilityBar>

    <div
      css={css`
        & > div {
          @media (max-width: 1199px) {
            background-size: cover;
          }
        }
      `}
    >
      <Hero
        imgDesktop={{
          file:
            'https://dcpd6wotaa0mb.cloudfront.net/owenscorning.com/assets/main/insulation/mechanical-pipe/desktop-wide@2x-cropped-281238722c20aa22ed2bd97179f968d967b206a54ad6c33dc23bdad3b25b5c42.jpg',
        }}
        imgTablet={{
          file:
            'https://dcpd6wotaa0mb.cloudfront.net/owenscorning.com/assets/main/insulation/mechanical-pipe/desktop-wide@2x-cropped-281238722c20aa22ed2bd97179f968d967b206a54ad6c33dc23bdad3b25b5c42.jpg',
        }}
        prehead="Commercial Insulation"
        h1="Find a Sales Representative"
        posthead=""
      />
    </div>

    <Container maxWidth="1170">
      <Banner>
        This content applies to those in the Commercial sector. Looking for help in{' '}
        <a href="/insulation/industrial/contact-sales-and-service">Industrial</a> or <a href="/contact-us">Residential</a>?
      </Banner>

      <section className="content-group">
        {aecData?.length > 0 && renderSection('Architect Technical Support', aecData, zipCodeAgentsData.zipcode)}
        {agentsData?.length > 0 && renderSection('Commercial Insulation Agents', agentsData, zipCodeAgentsData.zipcode)}
      </section>
    </Container>
  </>
);

export default wrappedInReduxProvider(connectLocation(SearchSalesRep));
